var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-steps-list"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"c-steps-list__description"},[_vm._v("\n        "+_vm._s(_vm.step.description)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }